import { Button, EmptyState, NoTasksIcon } from '@bp/ui-components';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNotifications } from '../../../../hooks/matrix/notifications/useNotifications';
import { useMessageCommands } from '../../../../matrix/commands/useMessageCommands';
import type { NotificationType } from '../../../../utils/matrixClient';
import styles from '../_Flyouts.module.scss';
import { NotificationItem } from './NotificationItem';

type NotificationsFlyoutContentProps = {
  navigate: (to: string) => void;
  onMarkAllAsRead: () => void;
};

export function NotificationsFlyoutContent({ navigate, onMarkAllAsRead }: NotificationsFlyoutContentProps) {
  const { t } = useTranslation();
  const { markAsRead } = useMessageCommands();

  const handleNotificationClick = async (notification: NotificationType) => {
    notification.targetUrl && navigate(notification.targetUrl);
    const eventId = notification.eventId;
    const roomId = notification.roomId;
    if (eventId && roomId) {
      await markAsRead(roomId);
    }
  };

  const notifications = useNotifications();

  return (
    <div className={classNames(styles['flyout-body'], styles.notifications)}>
      <div className={styles.header}>
        <div className={styles.headline}>{t('notifications.title')}</div>
        <Button hierarchy='ghost' disabled={notifications?.length === 0} onClick={onMarkAllAsRead}>
          {t('common.mark')}
        </Button>
      </div>

      <div className={classNames(styles.content, 'has-scrollbar')}>
        {notifications?.length === 0 ? (
          <EmptyState
            className={styles.empty}
            forcedHeight='400px'
            fitParent
            padding='xl'
            borderRadius='none'
            title={t('notifications.noNotifications')}
            icon={<NoTasksIcon />}
            iconColor='var(--color-primary-light)'
          />
        ) : (
          notifications?.map((n) => (
            <NotificationItem key={n.eventId} notification={n} onClick={handleNotificationClick} />
          ))
        )}
      </div>
    </div>
  );
}
